module.exports = __webpack_public_path__ + "static/media/breakfast.216664ff.png";